export var selectAffiliateConfigParams = function selectAffiliateConfigParams(state) {
  return state.affiliateConfig ? state.affiliateConfig : null;
};